module.exports = __webpack_public_path__ + "img/computer.42ed17a0.png";